"use strict";

const HardAssetInventoryConfig = function () {
  const defaultPages = ["setLocation", "generalInfo"];

  const configByAssetType = {
    pipe: { editPermissionKey: "can_edit_pipe", pages: defaultPages },
    manhole: { editPermissionKey: "can_edit_manhole", pages: defaultPages },
    culvert: { editPermissionKey: "can_edit_culvert", pages: defaultPages },
    openChannel: { editPermissionKey: "can_edit_open_channel", pages: defaultPages },
    liftStation: { editPermissionKey: "can_edit_lift_station", pages: defaultPages },
    cleanout: { editPermissionKey: "can_edit_cleanout", pages: defaultPages },
    bmpFcs: {
      editPermissionKey: "possibly_edit_bmp",
      designPhase: "planned",
      pages: [...defaultPages, "drainageArea"],
    },
    // Cleanouts and lift stations also have a rotation, but only outfalls draw it on the marker
    outfall: {
      editPermissionKey: "can_edit_outfall",
      marker: "rotating",
      pages: defaultPages,
    },
  };

  var getEditPermissionKey = function (assetType) {
    return configByAssetType[assetType].editPermissionKey;
  };

  var getInventoryPages = function (assetType) {
    return configByAssetType[assetType].pages;
  };

  var hasRotatingMarker = function (assetType) {
    return configByAssetType[assetType].marker === "rotating";
  };

  var phaseHasInstallDate = function (phase) {
    return SharedDataFunctions.isPhaseOrLater(phase, "construction");
  };

  // The API reports the design phase using the `design` code from the phase domain, which
  // structural BMPs store as `planned`.
  var getAssetPhase = function (assetType, phase) {
    if (phase !== "design") {
      return phase;
    }

    return configByAssetType[assetType].designPhase ?? phase;
  };

  return {
    getEditPermissionKey,
    getInventoryPages,
    hasRotatingMarker,
    phaseHasInstallDate,
    getAssetPhase,
  };
};

module.exports = HardAssetInventoryConfig();

const SharedDataFunctions = require("../../general/sharedDataFunctions");
